import r from"./exportData.js";import o from"./exportFormatter.js";var t=function(t,e,a,n){var p=new o(a,n).format(t,e),m=new r;return p?m.export(t,p.dataSource,p.options):null};export{t as exportData};
